import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Card, Tab } from '@mui/material';
import { useParams } from 'react-router-dom';
import React, { useState } from 'react';
import PaymentsCustomer from './PaymentsCustomer';
import BillTable from './BillTable';

function CustomerAccountTables({ customer }) {
  const [value, setValue] = useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Card>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChange}>
            <Tab label="Payments" value="1" />
            <Tab label="Pending Invoices" value="2" />
            <Tab label="Paid Invoices" value="3" />
          </TabList>
        </Box>
        <TabPanel value="1">
          <PaymentsCustomer customer={customer} />{' '}
        </TabPanel>
        <TabPanel value="2">
          <BillTable status={'pending'} customerId={customer._id} customer={customer} />
        </TabPanel>
        <TabPanel value="3">
          <BillTable status={'completed'} customerId={customer._id} customer={customer} />
        </TabPanel>
      </TabContext>
    </Card>
  );
}

export default CustomerAccountTables;
